'use strict';

// import { PERMISSIONS } from '../Permissions';

const BETA_FEATURES= {
  // [PERMISSIONS.LINKEDIN]: PERMISSIONS.LINKEDIN,
};

export {
  BETA_FEATURES,
};
